const ADD_NEW_DEVICES_TO_DEVICE_STATUSES = "device-status::add-new-devices";
const CLEAR_AND_LOAD_DEVICE_STATUSES = "device-status::clear-load-all";
const SET_DEVICE_STATUSES = "device-status::set";
const UPDATE_ALL_DEVICE_STATUSES = "device-status::update-status::all";

function clearAndLoadDeviceStatusesAction(payload) {
  return {
    payload,
    type: CLEAR_AND_LOAD_DEVICE_STATUSES,
  };
}

function setDeviceStatusesAction(payload) {
  return {
    payload,
    type: SET_DEVICE_STATUSES,
  };
}

function updateAllDeviceStatusesAction(payload) {
  return {
    payload,
    type: UPDATE_ALL_DEVICE_STATUSES,
  };
}

function addNewDevicesToDeviceStatusesAction(devices) {
  const payload = { devices };

  return {
    payload,
    type: ADD_NEW_DEVICES_TO_DEVICE_STATUSES,
  };
}

export {
  ADD_NEW_DEVICES_TO_DEVICE_STATUSES,
  addNewDevicesToDeviceStatusesAction,
  CLEAR_AND_LOAD_DEVICE_STATUSES,
  clearAndLoadDeviceStatusesAction,
  SET_DEVICE_STATUSES,
  setDeviceStatusesAction,
  UPDATE_ALL_DEVICE_STATUSES,
  updateAllDeviceStatusesAction,
};
